import Particles from "./particles";
import { PARTICLE_MAX_LIFETIME } from "./constants";
export { PARTICLE_MAX_LIFETIME };
export default Particles;
